import AuthService from "./AuthService"
import ApiService from "./ApiService";

class CategoryService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._attributeUrl = '/categories/attribute-with-count';
        this._categoryByNameUrl = '/categories/get-by-name';
        this._subcategoriesWithCountUrl = '/categories/sub-with-count';
        this._subcategoriesWithCountlist = '/categories/sub-with-count-list';
        this._mainCategoriesUrl = '/add-product/info/main-categories';
        this._regionUrl = '/categories/region-with-count';
        this._subCategoriesUrl = '/add-product/info/sub-categories';
    }

    getAttributeWithCount(attribute, value) {
        return this.postResource(this._attributeUrl, {attribute, value}, this.getLangHeader())
    }

    getCategoryByName(name, parentName) {
        return this.postResource(this._categoryByNameUrl, {name, parentName}, this.getLangHeader())
    }

    getRegionWithCount(id) {
        return this.postResource(this._regionUrl, {id}, this.getLangHeader())
    }

    getSubcategoriesWithCount(params) {
        return this.postResource(this._subcategoriesWithCountUrl, params, this.getLangHeader())
    }

    getSubCategoriesWithCountList() {
        return this.postResource(this._subcategoriesWithCountlist, {}, this.getLangHeader())
    }

    getMainCategories() {
        return this.postResource(this._mainCategoriesUrl, {}, this.getLangHeader())
    }
    getSubCategories(parentId) {
        return this.postResource(this._subCategoriesUrl, {categoryId: parentId}, this.getLangHeader())
    }

}

const categoryService = new CategoryService(AuthService);

export default categoryService;
